import { DownloadOutlined, FilePdfOutlined, WindowsOutlined } from '@ant-design/icons';
import { Button, Col, Divider, List, Row, Select } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { downloadVersions } from 'config/downloadVersions';

const fileIcon = { style: { fontSize: '22px' } };

const FILE_TYPE_ICON = {
	installer: <WindowsOutlined {...fileIcon} />,
	pdf: <FilePdfOutlined {...fileIcon} />,
};

const renderFileList = (files) => (
	<List
		itemLayout="horizontal"
		dataSource={files}
		renderItem={(file) => (
			<List.Item
				actions={[
					<Button key="download" type="primary" icon={<DownloadOutlined />} href={file.path} download>
						Download
					</Button>,
				]}
			>
				<List.Item.Meta avatar={FILE_TYPE_ICON[file.type]} title={file.label} />
			</List.Item>
		)}
	/>
);

const DownloadsPage = () => {
	const [selectedVersion, setSelectedVersion] = useState(downloadVersions[0].version);

	const currentVersion = downloadVersions.find((v) => v.version === selectedVersion) || downloadVersions[0];
	const { installer, installGuide, userManual } = currentVersion.files;

	return (
		<div>
			<Row align="middle" justify="space-between">
				<Col>
					<Label>Softwares</Label>
				</Col>
				<Col>
					<Select value={selectedVersion} onChange={setSelectedVersion} style={{ width: 160 }}>
						{downloadVersions.map((v) => (
							<Select.Option key={v.version} value={v.version}>
								Version {v.version}
							</Select.Option>
						))}
					</Select>
				</Col>
			</Row>
			<StyledDivider />

			<Row gutter={24}>
				<Col xs={24} md={11}>
					<SectionLabel>Installer</SectionLabel>
					{renderFileList([installer])}
				</Col>
				<Col xs={0} md={2} style={{ display: 'flex', justifyContent: 'center' }}>
					<ColumnDivider type="vertical" />
				</Col>
				<Col xs={24} md={11}>
					<SectionLabel>Documentation</SectionLabel>
					{renderFileList([installGuide, userManual])}
				</Col>
			</Row>
		</div>
	);
};

export default DownloadsPage;

// style
const StyledDivider = styled(Divider)`
	margin: 5px 0;
	padding: 0;
`;
const Label = styled.div`
	font-size: 24px;
	font-weight: 600;
	line-height: 1.2;
	letter-spacing: 0.5px;
	color: #333333;
	margin-top: 10px;
	margin-bottom: 14px;
`;
const SectionLabel = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: #333333;
	margin-top: 20px;
	margin-bottom: 8px;
`;
const ColumnDivider = styled(Divider)`
	height: 100%;
	margin: 0;
`;
